// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hiqx","content":"styles_content__kFMl7"};